export enum HtmlTag {
    LINK = 'A',
    BUTTON = 'BUTTON'
}
